"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgMobileBroadband(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M16 9c-1.827 1.406-3 3.569-3 6 0 2.43 1.173 4.593 3 6", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M20 22v15", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 18a3 3 0 11-.001-5.999A3 3 0 0120 18z", fill: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M24 9c1.827 1.406 3 3.569 3 6 0 2.43-1.173 4.593-3 6M12 5c-3.045 2.344-5 5.948-5 10 0 4.05 1.955 7.656 5 10M28 5c3.045 2.344 5 5.948 5 10 0 4.05-1.955 7.656-5 10", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
}
exports.default = SvgMobileBroadband;
//# sourceMappingURL=MobileBroadband.js.map